import { HeightRule, Table, TableRow, WidthType, TableLayoutType } from "docx";
import { noten } from "../../../data/noten";
import Calculations from "../../../helpers/calculations";
import {
  tableCellMain,
  tableCellMainRight,
  tableCellWithColSpan,
  tableCellWithRowSpanBorders,
} from "./tableCell";

export const conclusionTableBerlin = (schueler, klausur) => {
  console.log({ klausur });
  const {
    sumAfb1Bis3AnteilRounded,
    prozentAufgabenbearbeitung,
    aufgabenBearbeitungGewichtung,
    sprachePointsAnteil,
    erreichteGesamtpunktzahl,
    resultPointsRounded,
  } = new Calculations(schueler, klausur).results.Berlin;
  return new Table({
    layout: TableLayoutType.FIXED, // Layout auf "fixed" setzen
    columnWidths: [3000, 900, 1500, 1200, 1600, 1500],
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows: [
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain("Bereiche"),
          tableCellMain("Punkte"),
          tableCellMain("Gewichtung"),
          tableCellMain("Ergebnis"),
          tableCellMain("Gesamtpunkte"),
          tableCellMain("Gesamtnote"),
        ],
      }),
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain("Aufgabenbearbeitung"),
          tableCellMainRight(`${sumAfb1Bis3AnteilRounded}`),
          tableCellMainRight(`${prozentAufgabenbearbeitung} %`),
          tableCellMainRight(`${aufgabenBearbeitungGewichtung.toFixed(2)}`),
          tableCellWithRowSpanBorders(`${resultPointsRounded}`, 3),
          tableCellWithRowSpanBorders(
            `${noten[`0${resultPointsRounded}`.slice(-2)]}`,
            3
          ),
        ],
      }),
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain("Sprachverwendung"),
          tableCellMainRight(`${parseInt(schueler.sprachePoints)}`),
          tableCellMainRight(`${klausur.sprachverwendung} %`),
          tableCellMainRight(`${sprachePointsAnteil.toFixed(2)}`),
        ],
      }),
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellWithColSpan("erreichte Gesamtpunktzahl", 3),
          tableCellMainRight(`${erreichteGesamtpunktzahl.toFixed(2)}`),
        ],
      }),
    ],
  });
};
